import "./container_component.css";

import "./bg-ellipsis.svg";
